import {Button, Card, Checkbox, Collapse, Spin, Typography,} from 'antd';
import {CaretRightOutlined, CheckOutlined, CloseOutlined} from '@ant-design/icons';
import {useEffect, useState} from "react";
import {use} from "i18next";
import {v4} from "uuid";
import {useProject} from "../Context/ProjectContext";
import HecRasHelper from "../Helpers/HecRasHelper";
import FilterText from "./FilterText";

const { Panel } = Collapse;

export const OPS_STATUS = {
    NOT_CHECK: 0,
    CHECKING: 1,
    COMPLETED: 2,
    ERROR: 3,
}

export default function OperationManager({operations, id, selected, summaryPanel, showKey, settings, type}) {
    const [key, setKey] = useState(v4())
    const [expand, setExpand] = useState(operations.map(x => x.title))
    const [selectedIndex, setSelectedIndex] = useState({
        x: 0,
        y: 0
    })
    const [_operations, set_operations] = useState([])

    const update = () => {
        if(operations) {
            set_operations(operations)
            setKey(key)
        }
    }

    useEffect(() => {
        update()
    }, [operations])

    useEffect(() => {
        if(selected) {
            setSelectedIndex(selected)
        }
    }, [selected])

    const onCheckedChanged = (title, childTitle, val) => {
        const ops = [..._operations]
        ops.forEach(x => {
            if(x.title === title) {
                x.children.forEach(y => {
                    if(y.title === childTitle) {
                        y.enable = val
                    }
                })
            }
        })
        set_operations(ops)
    }

    const onCheckAll = (title, val) => {
        const ops = [..._operations]
        ops.forEach(x => {
            if(x.title === title) {
                x.children.forEach(y => {
                    y.enable = val
                })
            }
        })
        set_operations(ops)
    }

    const getAllTime = () => {
        let time = 0;
        _operations.forEach(item => {
            item.children.forEach(child => {
                time += child.time
            })
        })
        return time.toFixed(1);
    }

    const renderOperations = () => {
        const errorColor = '#ee5253'
        const successColor = '#27ae60'
        const normalColor = '#0f0f0f'
        const selectedColor = '#01a3a4'

        const renderHeader = (op, idx) => {

            const getHeaderColor = (completed, showIndicator, idx) => {
                if(completed && showIndicator)
                    return errorColor
                else if(completed && !showIndicator)
                    return successColor
            }

            const checked = op.children.filter(item => item.enable).length === op.children.length;
            const checking = op.children.filter(item => item.enable && item.status === OPS_STATUS.CHECKING).length > 0
            const completed = op.children.filter(item => item.status === OPS_STATUS.COMPLETED).length > 0
            const showIndicator = op.children.filter(item => item.showIndicator && item.showIndicator({data: item.result})).length > 0
            const intermediate = op.children.filter(item => item.enable).length > 0;

            let time = 0;
            op.children.forEach(x => x.time && (time += x.time))

            return (
                <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                    <div onClick={(e) => {e.stopPropagation()}}>
                        <Checkbox
                            disabled={checking}
                            checked={checked}
                            indeterminate={!checked && intermediate}
                            onChange={(e) => {
                                onCheckAll(op.title, e.target.checked)
                            }}
                        />
                    </div>
                    <span
                        style={{
                            color: getHeaderColor(completed, showIndicator, idx),
                            fontWeight: selectedIndex.x === idx ? 'bold' : ''
                        }}
                    >
                        {`${op.title}`}
                    </span>
                    {
                        checking && (
                            <Spin size={'small'}/>
                        )
                    }
                    {
                        completed && !showIndicator && (
                            <span style={{color: successColor}}>
                                ({time.toFixed(1)} s)
                            </span>
                        )
                    }
                    {
                        completed && showIndicator && (
                            <div style={{color: errorColor, display: 'flex', alignItems: 'center', gap: 4}}>
                                ({time.toFixed(1)} s)
                            </div>
                        )
                    }
                </div>
            )
        }

        return _operations.map((op, idx) => {
            return (
                <Panel showArrow={false} key={op.title} header={renderHeader(op, idx)}>
                    <div style={{marginLeft: 12}}>
                        <table>
                            {
                                op.children.map((item, idy) => {
                                    const getChildFontColor = (status, idx, idy, showIndicator) => {
                                        if(status === OPS_STATUS.COMPLETED && !showIndicator)
                                            return successColor
                                        else if(status === OPS_STATUS.COMPLETED && showIndicator)
                                            return errorColor
                                        else
                                            return normalColor
                                    }

                                    const showIndicator = item.showIndicator && item.showIndicator({data: item.result})

                                    return (
                                        <tr key={v4()}>
                                            <div style={{display: 'flex', gap: 4, alignItems: 'center'}}>
                                                <Checkbox
                                                    disabled={_operations.filter(x => x.children.filter(y => y.status === OPS_STATUS.CHECKING).length > 0).length > 0}
                                                    checked={item.enable}
                                                    onChange={(e) => {
                                                        onCheckedChanged(op.title, item.title, e.target.checked)
                                                    }}
                                                />
                                                <a
                                                    onClick={() => {setSelectedIndex({x: idx, y: idy})}}
                                                    style={{
                                                        color: getChildFontColor(item.status, idx, idy, showIndicator),
                                                        fontWeight: selectedIndex.x === idx && selectedIndex.y === idy ? 'bold' : '',
                                                        flex: 1
                                                    }}
                                                >
                                                    {item.title}
                                                    <span style={{marginLeft: 16}}>
                                                        {showKey && (`(${item.key[0]}.${item.key.substring(1)})`)}
                                                    </span>
                                                </a>
                                                {
                                                    item.status === OPS_STATUS.COMPLETED && showIndicator && (
                                                        <>
                                                            <span style={{color: errorColor}}>
                                                                {/*({item.time.toFixed(1)} s)*/}
                                                            </span>
                                                        </>

                                                    )
                                                }
                                                {
                                                    item.status === OPS_STATUS.CHECKING && (
                                                        <Spin size={'small'}/>
                                                    )
                                                }
                                                {
                                                    item.status === OPS_STATUS.COMPLETED && !showIndicator && (
                                                        <span style={{color: successColor}}>
                                                            {/*({item.time.toFixed(1)} s)*/}
                                                        </span>
                                                    )
                                                }
                                                {
                                                    item.status === OPS_STATUS.ERROR && (
                                                        <span style={{color: errorColor}}><CloseOutlined /></span>
                                                    )
                                                }
                                            </div>
                                        </tr>
                                    )
                                })
                            }
                        </table>
                    </div>
                </Panel>
            )
        })
    }

    const renderContent = () => {
        if(selectedIndex.x === -1 && selectedIndex.y === -1) {
            if(summaryPanel)
                return summaryPanel()
            else
                return
        }

        if(_operations.length > 0 && selectedIndex.x < _operations.length) {
            const child = _operations[selectedIndex.x].children[selectedIndex.y];
            const Component = child.Component;

            return (
                <Card style={{height: '100%'}}>
                    <Typography.Title level={5}>
                        {child.title} {showKey && (` (${child.key[0]}.${child.key.substring(1)})`)}
                    </Typography.Title>
                    <FilterText type={type} />
                    <Component
                        data={{
                            ...child.result,
                            key: child.key
                        }}
                        status={child.status}
                        noIssueText={child.noIssueText}
                        settings={settings}
                    />
                </Card>
            )
        }

        if(summaryPanel)
            return summaryPanel()
    }

    return (
        <>
            <div style={{display: 'flex', width: '100%', gap: 8}} key={key}>
                {
                    id && (
                        <>
                            <div>
                                <Collapse style={{minWidth: 372}} defaultActiveKey={expand}>
                                    {
                                        summaryPanel && (
                                            <div className="ant-collapse-item ant-collapse-no-arrow">
                                                <div
                                                    onClick={() => {setSelectedIndex({x: -1, y: -1})}}
                                                    className="ant-collapse-header"
                                                    aria-expanded="false"
                                                    aria-disabled="false"
                                                    role="button"
                                                    tabIndex="0">
                                                    <div
                                                        onClick={(e) => {e.stopPropagation()}}
                                                        style={{marginRight: 8}}
                                                    >
                                                        <Checkbox
                                                            disabled={_operations.find(x => x.children.find(y => y.status === OPS_STATUS.CHECKING))}
                                                            checked={!_operations.find(x => x.children.find(y => !y.enable))}
                                                            onChange={(e) => {
                                                                const ops = [..._operations]
                                                                ops.forEach(x => {
                                                                    x.children.forEach(y => {
                                                                        y.enable = e.target.checked
                                                                    })
                                                                })
                                                                set_operations(ops)
                                                            }}
                                                        />
                                                    </div>
                                                    <span className="ant-collapse-header-text">
                                                        <span style={{fontWeight: selectedIndex.x === -1 && selectedIndex.y === -1 ? 'bold' : ''}}>
                                                            <div>
                                                                Summary (Total Time: {getAllTime()} s)
                                                            </div>
                                                        </span>
                                                    </span>
                                                </div>
                                            </div>
                                        )
                                    }
                                    {renderOperations()}
                                </Collapse>
                            </div>
                            <div style={{width: '100%'}}>
                                {renderContent()}
                            </div>
                        </>
                    )
                }
            </div>
        </>
    )
}